import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Header from "../../app/universalComponents/Header";
import Footer from "../../app/universalComponents/Footer";
import Loading from "../../app/universalComponents/Loading";
import NotFoundPage from "../not-found/NotFoundPage";
import { api } from "../../app/http/axiosClient";

export default function DonationSuccessPage() {
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("session_id");

  const [emailStatus, setEmailStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function getDonationStatus() {
      try {
        setLoading(true);
        setError(false);

        const response = await api.get(
          `/donations/status/${encodeURIComponent(sessionId)}`
        );

        const donationStatus = response.data.donation_status;
        const returnedEmailStatus = response.data.email_status;

        if (donationStatus !== "paid") {
          setError(true);
          return;
        }

        setEmailStatus(returnedEmailStatus);
      } catch (err) {
        console.error(err.response?.data ?? err);
        setError(true);
      } finally {
        setLoading(false);
      }
    }

    if (sessionId) {
      getDonationStatus();
    } else {
      setError(true);
      setLoading(false);
    }
  }, [sessionId]);

  useEffect(() => {
    document.title = "Donation Successful | Tickets.NP";
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <NotFoundPage />;
  }

  return (
    <div className="flex min-h-screen flex-col">
      <Header />

      <main className="flex flex-1 items-center justify-center px-6 py-16">
        <section className="mx-auto w-full max-w-xl text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-500">
            Donation successful
          </p>

          <h1 className="mt-4 text-4xl font-bold tracking-tight lg:text-5xl">
            Thank you for your donation
          </h1>

          <hr className="mx-auto my-6 h-px w-56 border-0 bg-gray-300" />

          {emailStatus === "sent" ? (
            <p className="text-base">
              A confirmation email for your donation has been sent.
            </p>
          ) : (
            <p className="text-base">
              Your donation was successful. Your confirmation email is being
              processed.
            </p>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}